import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Loader from '../Loader';

function RegistrationModal() {
    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')
    const [confirm, setConfirm] = useState(false)
    const [isLoader, setIsLoader] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [validateErrorEmail, setValidateErrorEmail] =  useState(false)
    const [validateErrorPassword, setValidateErrorPassword] =  useState(false)
    const [validateErrorConfirm, setValidateErrorConfirm] =  useState(false)
    // const escFunction = useCallback((event) => {
    //     if (event.key === 'Escape') {
    //         setIsAtiveModal(false);
    //     }
    //   }, []);
    
    //   useEffect(() => {
    //     document.addEventListener('keydown', escFunction, false);
    
    //     return () => {
    //       document.removeEventListener('keydown', escFunction, false);
    //     };
    //   }, []);

    // const checkFormHandler = (e)=> {
    //     e.stopPropagation()
    // }

    const submitHandler = async (e) =>{
        e.preventDefault()
        if(!checkInputsToSendData()){
            return
        }
        const token = "821717A5FDF14D57A347";
        setDisabled(true)
        setIsLoader(true);
        return await axios({
            method: "post",
            timeout: 10000 * 5,
            url: " http://api.vodokomfort.ru/ridan/registration",
            headers: {
                "content-type": "application/json",
                "Cache-Control": "no-cache",
                Authorization: `Bearer ${token}`,
                Accept: "/",
            },
            data:{email: login,
                password: password,
                confirmed: confirm}
    })
      .then((data) => {
        console.log(data)
      })
      .then(() => setIsLoader(false))
      .catch((err) => {
        console.error(err);
        // setIsLoader(false);
        // setDisabled(false)
      });
    }

    const onChangeLoginHandler = (e) => {
        setValidateErrorEmail(false)
        setLogin(e.target.value)
    }

    const onChangePasswordHandler = (e) => {
        setValidateErrorPassword(false)
        setPassword(e.target.value)
    }

    const checkInputsToSendData = () => {
        let expEmail = /\S+@\S+\.\S+/;
        if(login.trim().length === 0 || !expEmail.test(login)){
            setValidateErrorEmail(true)
            return
        }
        if(password.trim().length < 6 ){
            setValidateErrorPassword(true)
            return
        }
        if(!confirm){
            setValidateErrorConfirm(true)
            return
        }
        return true
    }

    // useEffect(()=>{
    //     // console.log(login, password, confirm);
    //     console.log()
    // },[login, password, confirm])
    
   
  return (
    <>
      <div className="page_header">Регистрация</div>
            <div className="interface-form_group">
                <input type="email" className={validateErrorEmail ? 'interface_input modal_input__error' : 'interface_input'} placeholder='Email' onChange ={(e)=>onChangeLoginHandler(e)}/>
                {
                    validateErrorEmail ? 
                    <div className='modal_validate__error'>Проверьте введенный email</div>   
                    :
                    null  
                }
            </div>
            <div className="interface-form_group">
                <input type="password"  className={validateErrorPassword ? 'interface_input modal_input__error' : 'interface_input'}  placeholder='Пароль' onChange ={(e)=>onChangePasswordHandler(e)}/>
                {  validateErrorPassword ? 
                    <div className='modal_validate__error'>Это поле не может быть меньше 6-ти символов</div>   
                    :
                    null } 
            </div>
            <div className="form_group-checkbox">
                <input type="checkbox" id="agreement" className="regular-checkbox" checked={confirm} onChange = {()=>{setConfirm(!confirm);setValidateErrorConfirm(false)}}/>
                <label htmlFor="agreement">Соглашаюсь</label>
                {
                    validateErrorConfirm ? <div className='modal_validate__error'>Согласитесь </div> : null  
                }
            </div>
            <div className="form_group-checkbox">
            <button className='interface_button button-xs' onClick ={(e)=>submitHandler(e)} disabled={disabled}>Зарегестрироваться</button>
            {isLoader ? <Loader /> : null}
            </div>
    </>
  )
}

export default RegistrationModal